import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import type { PackageType } from 'shared/packages/domain/packageType';
import { usePackageTypeStore } from 'shared/packages/stores/packageTypeStore';

export interface UpdatePackageType {
  name: string;
  pieces: number;
  layers: number | null;
  piecesPerLayer: number | null;
  spacerHeight: number | null;
  packagingIds: string[];
}

export interface UpdatePackageTypeResponse {
  ok: true;
  packageType: PackageType;
}

export function useUpdatePackageType() {
  const store = usePackageTypeStore();

  return useUpdateEntityApi<UpdatePackageType, UpdatePackageTypeResponse>({
    url: 'packageType',
    translate: (t) => t.packageTypes.actions.update,
    async processOk(response) {
      const json = await response.json() as PackageType;
      store.add(json);
      return {
        ok: true,
        packageType: json,
      };
    },
  });
}
